import {
	PlatformLogsFilterObject,
	ChannelLogsFilterObject,
	WorkerLogsFilterObject,
	CallLogsFilterObject,
	AllLogsFilterObject,
} from "../../models/TwilioModels";
import moment from "moment";
import {
	generatePlatformLogsDefaultFilters,
	generateChannelLogsDefaultFilters,
	generateWorkerLogsDefaultFilters,
	generateCallLogsDefaultFilters,
	generateAllLogsDefaultFilters,
} from "../../utils";
import { getLocalStorageValue, setLocalStorageValue } from "./LocalStorage";

/**
 * This method corrects the start and end date in the filter object if the refreshDateTimespan is set.
 * refreshDateTimespan being set would mean that the dates being used are
 * supposed to be startdate = now - refreshDateTimespan and end date of the current time.
 */
const correctDatesToTimespan = (
	filterObject: AllLogsFilterObject | CallLogsFilterObject | ChannelLogsFilterObject | PlatformLogsFilterObject,
) => {
	const value = filterObject;
	if (value["refreshDateTimespan"] !== undefined && value["refreshDateTimespan"] !== 0) {
		value["startDate"] = moment().subtract(value["refreshDateTimespan"], "hours").toDate();
		value["endDate"] = moment().toDate();
	}
	return value;
};

//All Logs retrieval methods
export const setAllLogsFiltersLocalStorageValue = (subscriptionId: string, value: AllLogsFilterObject) => {
	setLocalStorageValue(["AllLogs", subscriptionId], value);
};

export const resetAllLogsFiltersLocalStorageValue = (subscriptionId: string) => {
	const defaultVal = generateAllLogsDefaultFilters();
	setLocalStorageValue(["AllLogs", subscriptionId], defaultVal);
	return defaultVal;
};

export const getAllLogsFiltersLocalStorageValue = (subscriptionId: string) => {
	let value: AllLogsFilterObject =
		(getLocalStorageValue(["AllLogs", subscriptionId]) as AllLogsFilterObject) || generateAllLogsDefaultFilters();
	value = correctDatesToTimespan(value) as AllLogsFilterObject;
	return value;
};

//Call Logs retrieval methods
export const setCallLogsFiltersLocalStorageValue = (subscriptionId: string, value: CallLogsFilterObject) => {
	setLocalStorageValue(["CallLogs", subscriptionId], value);
};

export const resetCallLogsFiltersLocalStorageValue = (subscriptionId: string) => {
	const defaultVal = generateCallLogsDefaultFilters();
	setLocalStorageValue(["CallLogs", subscriptionId], defaultVal);
	return defaultVal;
};

export const getCallLogsFiltersLocalStorageValue = (subscriptionId: string) => {
	let value: CallLogsFilterObject =
		(getLocalStorageValue(["CallLogs", subscriptionId]) as CallLogsFilterObject) || generateCallLogsDefaultFilters();
	value = correctDatesToTimespan(value) as CallLogsFilterObject;
	return value;
};

//Channel Logs retrieval methods
export const setChannelLogsFiltersLocalStorageValue = (subscriptionId: string, value: ChannelLogsFilterObject) => {
	setLocalStorageValue(["ChannelLogs", subscriptionId], value);
};

export const resetChannelLogsFiltersLocalStorageValue = (subscriptionId: string) => {
	const defaultVal = generateChannelLogsDefaultFilters();
	setLocalStorageValue(["ChannelLogs", subscriptionId], defaultVal);
	return defaultVal;
};

export const getChannelLogsFiltersLocalStorageValue = (subscriptionId: string): ChannelLogsFilterObject => {
	let value: ChannelLogsFilterObject =
		(getLocalStorageValue(["ChannelLogs", subscriptionId]) as ChannelLogsFilterObject) ||
		generateChannelLogsDefaultFilters();
	value = correctDatesToTimespan(value) as ChannelLogsFilterObject;
	return value;
};

//Worker Logs retrieval methods
export const setWorkerLogsFiltersLocalStorageValue = (subscriptionId: string, value: WorkerLogsFilterObject) => {
	setLocalStorageValue(["WorkerLogs", subscriptionId], value);
};

export const resetWorkerLogsFiltersLocalStorageValue = (subscriptionId: string) => {
	const defaultVal = generateWorkerLogsDefaultFilters();
	setLocalStorageValue(["WorkerLogs", subscriptionId], defaultVal);
	return defaultVal;
};

export const getWorkerLogsFiltersLocalStorageValue = (subscriptionId: string): WorkerLogsFilterObject => {
	const value: WorkerLogsFilterObject =
		(getLocalStorageValue(["WorkerLogs", subscriptionId]) as WorkerLogsFilterObject) ||
		generateWorkerLogsDefaultFilters();
	return value;
};

//Platform Event retrieval methods
export const setPlatformLogsFiltersLocalStorageValue = (value: PlatformLogsFilterObject) => {
	setLocalStorageValue(["PlatformLogs"], value);
};

export const resetPlatformLogsFiltersLocalStorageValue = () => {
	const defaultVal = generatePlatformLogsDefaultFilters();
	setLocalStorageValue(["PlatformLogs"], defaultVal);
	return defaultVal;
};

export const getPlatformLogsFiltersLocalStorageValue = (): PlatformLogsFilterObject => {
	let value: PlatformLogsFilterObject =
		(getLocalStorageValue(["PlatformLogs"]) as PlatformLogsFilterObject) || generatePlatformLogsDefaultFilters();
	value = correctDatesToTimespan(value) as PlatformLogsFilterObject;
	return value;
};
